// src/hooks/media/useDeleteMedia.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteMedia, deleteMultipleMedia } from "../../api/apiMedias";
import parseError from "../../utils/parseError";

/**
 * Hook to delete single or multiple media files
 */
const useDeleteMedia = () => {
    const queryClient = useQueryClient();

    // Single delete mutation
    const {
        mutate: deleteSingleMedia,
        isPending: isDeletingSingle,
    } = useMutation({
        mutationFn: deleteMedia,
        onSuccess: (response) => {
            toast.success(response.message || "Media deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["media"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete media");
        },
    });

    // Multiple delete mutation
    const {
        mutate: deleteMultipleMediaMutate,
        isPending: isDeletingMultiple,
    } = useMutation({
        mutationFn: deleteMultipleMedia,
        onSuccess: (response) => {
            toast.success(response.message || "Media files deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["media"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete media files");
        },
    });

    return {
        deleteSingleMedia,
        deleteMultipleMediaMutate,
        isDeleting: isDeletingSingle || isDeletingMultiple,
        isDeletingSingle,
        isDeletingMultiple,
    };
};

export default useDeleteMedia;
